export default __webpack_public_path__ + "static/media/715.c70d93ce.png";